function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconMic = function SvgIconMic(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: props.color,
    d: "M18 13c0 3.16-3 5.66-6 5.66S6 16.16 6 13m6 6v2m-3 0h6m-3-5a4 4 0 0 1-4-4V6a4 4 0 1 1 8 0v6a4 4 0 0 1-4 4z"
  }));
};
export default SvgIconMic;